/**
 * Core skills, grouped exactly as they are framed on the résumé
 * (AI/ML first — that is the current focus).
 */
export const skillGroups = [
  {
    id: 'ai',
    title: 'AI / Machine Learning Engineering',
    blurb:
      'Turning LLMs into systems that hold up in production — orchestrated, evaluated, observable and provider-agnostic.',
    featured: true,
    skills: [
      'LLM Applications',
      'Generative AI',
      'RAG',
      'Conversational AI',
      'Prompt Engineering',
      'AI Agents & Workflows',
      'Knowledge-Based AI',
      'LLM API Integration',
      'Context Management',
      'AI Evaluation',
      'AI-Assisted Development',
    ],
  },
  {
    id: 'backend',
    title: 'Backend & Distributed Systems',
    blurb:
      'Service boundaries, API contracts and failure behaviour designed before the first line of handler code.',
    featured: true,
    skills: [
      'Python',
      'FastAPI',
      'Go',
      'Node.js',
      'NestJS',
      'C# / .NET',
      'REST APIs',
      'Microservices',
      'Event-Driven Architecture',
      'WebSockets',
      'Background Jobs',
      'API Design',
      'Service Architecture',
    ],
  },
  {
    id: 'frontend',
    title: 'Full-Stack Development',
    blurb: 'Interfaces that expose complex systems without leaking their complexity.',
    skills: [
      'React',
      'Next.js',
      'TypeScript',
      'JavaScript',
      'Vue.js',
      'Nuxt.js',
      'Responsive Applications',
      'State Management',
      'API Integration',
    ],
  },
  {
    id: 'data',
    title: 'Databases & Data',
    blurb: 'Schemas, indexes and query plans tuned for real production workloads.',
    skills: [
      'PostgreSQL',
      'MongoDB',
      'MySQL',
      'SQL Server',
      'DynamoDB',
      'Firestore',
      'Prisma',
      'GORM',
      'Entity Framework Core',
      'Data Modeling',
      'Query Optimization',
    ],
  },
  {
    id: 'cloud',
    title: 'Cloud & Infrastructure',
    blurb: 'Containerised delivery, reproducible environments and pipelines that catch problems early.',
    skills: [
      'Docker',
      'Kubernetes',
      'AWS',
      'GCP',
      'Azure',
      'Cloud Run',
      'Lambda',
      'API Gateway',
      'S3',
      'RDS',
      'CloudWatch',
      'CI/CD',
      'GitHub Actions',
    ],
  },
  {
    id: 'security',
    title: 'Security & Integrations',
    blurb: 'Auth, access control and third-party rails built to financial-grade expectations.',
    skills: [
      'OAuth2',
      'JWT',
      'RBAC',
      'API Security',
      'Payment Gateways',
      'Banking APIs',
      'Third-Party APIs',
      'Webhooks',
      'Enterprise Integrations',
    ],
  },
  {
    id: 'leadership',
    title: 'Technical Leadership',
    blurb: 'Hands-on lead: architecture, review standards, incident command and growing the engineers around me.',
    skills: [
      'System Architecture',
      'Technical Leadership',
      'Engineering Mentoring',
      'Code Review',
      'Technical Decision Making',
      'Root Cause Analysis',
      'Production Incident Management',
      'Technical Planning',
      'Agile / Scrum',
    ],
  },
];
